'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _client = require('../client');

var _client2 = _interopRequireDefault(_client);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  fetch: function fetch(userName, reservationId) {
    return _client2.default.get('1/users/' + userName + '/reservations/' + reservationId);
  },
  update: function update(userName, uid, data, query) {
    return _client2.default.patchJson('1/users/' + userName + '/reservations/' + uid, data, query);
  },
  messages: function messages(uid, params) {
    return _client2.default.get('1/reservations/' + uid + '/messages', params);
  },
  createMessage: function createMessage(userName, uid, message, file, isAuto) {
    var form = new FormData();
    form.append('content', message);
    if (file) {
      form.append('file', file);
    }
    if (isAuto) {
      form.append('is_auto', isAuto);
    }
    return _client2.default.postFormData('1/users/' + userName + '/reservations/' + uid + '/messages', form);
  },
  approveChange: function approveChange(uid, reservationId, params) {
    return _client2.default.patchJson('1/users/' + uid + '/reservations/' + reservationId + '/approve_change', params);
  },
  rejectChange: function rejectChange(uid, reservationId, params) {
    return _client2.default.patchJson('1/users/' + uid + '/reservations/' + reservationId + '/reject_change', params);
  },
  cancel: function cancel(uid, reservationId, params) {
    return _client2.default.patchJson('1/users/' + uid + '/reservations/' + reservationId + '/cancel', params);
  },
  reputation: function reputation(uid, reservationId, params) {
    return _client2.default.get('1/users/' + uid + '/reservations/' + reservationId + '/reputation', params);
  },
  createReputation: function createReputation(uid, reservationId, params) {
    return _client2.default.postJson('1/users/' + uid + '/reservations/' + reservationId + '/reputation', params);
  },
  updateReputation: function updateReputation(uid, reservationId, params) {
    return _client2.default.patchJson('1/users/' + uid + '/reservations/' + reservationId + '/reputation', params);
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/frontend_core/dist/rest/resources/userReservation.js
// module id = 525
// module chunks = 0